import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4e7cb2e9"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "container pt-4"
}
const _hoisted_2 = { class: "row my-3" }
const _hoisted_3 = { class: "col-12 text-center" }
const _hoisted_4 = { class: "text-center py-3" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "text-center" }, " Un asesor de la concesionaria se comunicará con vos a la brevedad. ", -1))
const _hoisted_6 = { class: "text-center py-3" }
const _hoisted_7 = { class: "col-12 text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppResumeComponent = _resolveComponent("AppResumeComponent")!
  const _component_AppButtonResetNav = _resolveComponent("AppButtonResetNav")!

  return (_ctx.state.navigation.vehiculo && _ctx.state.evento)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_AppResumeComponent, { logo: "/img/icons/checked.svg" }),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", _hoisted_4, " ¡Gracias por tu interés en " + _toDisplayString(_ctx.state.navigation.vehiculo.title) + " " + _toDisplayString(_ctx.state.navigation.vehiculo.subtitle) + "! ", 1),
            _hoisted_5,
            _createElementVNode("h4", _hoisted_6, " ¡Esperamos que pronto disfrutes de tu nuevo " + _toDisplayString(_ctx.state.evento.marca?.replace('_', '').toUpperCase()) + "! ", 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_AppButtonResetNav)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}